import * as React from "react";
import { WithStyles, withStyles, Theme, createStyles, Typography } from "@material-ui/core";
import { RouteComponentProps } from "react-router-dom";
import { appBarHeight } from "src/customTheme";

interface UrlParams {
  title: string;
}

interface VideoProps extends WithStyles<typeof styles>, RouteComponentProps<UrlParams> {
  title: string;
  path: string;
}

class Video extends React.PureComponent<VideoProps> {
  render() {
    const { classes, match } = this.props;
    return (
      <div className={classes.root}>
        <Typography variant="h6" className={classes.title}>
          {decodeURIComponent(match.params.title)}
        </Typography>
        <video controls={true} preload="auto" className={classes.video}>
          <source src={`${location.hash.replace("#/help/", "")}.mp4`} type="video/mp4" />
          {/* Fallback */}
          Sorry, your browser does not support HTML5 videos.
        </video>
      </div>
    );
  }
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      height: `calc(100vh - ${appBarHeight.sm + 10}rem)`
    },
    title: {
      height: "2.5rem",
      marginBottom: "1rem",
      textAlign: "center"
    },
    video: {
      display: "block",
      padding: "1rem",
      maxWidth: "100%",
      maxHeight: "100%",
      marginLeft: "auto",
      marginRight: "auto",
      /* Setting width & height to auto prevents the browser from stretching or squishing the video */
      width: "auto",
      height: "auto"
    }
  });

export default withStyles(styles)(Video);
